<script setup lang="ts">
import type { NovaHeaderRightSideProps } from '@components/NovaHeaderRightSide/NovaHeaderRightSide.types'

withDefaults(defineProps<NovaHeaderRightSideProps>(), {
  scroll: false,
})
</script>

<template>
  <aside :class="['right-side-bar', { scroll }]">
    <slot />
  </aside>
</template>

<style lang="scss" scoped>
.right-side-bar {
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  width: $right-side-bar-width;
  height: 100%;
  padding-top: $main-vertical-padding;
  padding-bottom: $main-vertical-padding;

  &.scroll {
    overflow-y: auto;
  }
}
</style>
